import { ObjectCreatorSourceMultiPanel } from "../components/multipanels/objectcreatorsource/objectcreatorsource.multipanel";

export const APP_MULTIPANELS = [
    ObjectCreatorSourceMultiPanel
]
